import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';

import { tap, filter, takeUntil } from 'rxjs/operators';

import { DlgStoreAccessKeyComponent } from './dlg-store-access-key';
import { TRANSFER_KEYS } from './dlg-store-access-key';
export { TRANSFER_KEYS } from './dlg-store-access-key';

import { SteamService } from '../shared-services.module/steam.service';

import { ToastrService } from '../toastr.module/toastr.service';
import { ToastTransferingAccessKeyComponent } from '../toastr.module/toast-transfering-access-key.component';
import { ToastSuccessAccessKeyComponent } from '../toastr.module/toast-success-access-key.component';

const PKG_ACCESS_KEY = 'accessKey';

interface IDlgStoreAccessKeyData {
    steam: any;
    amount: number;
    unlimitedAccessKeys: boolean;
}

@Injectable()
export class ShowDlgStoreAccessKeyService {
    dialogRef: MatDialogRef<DlgStoreAccessKeyComponent>;

    resolve: (value?: any) => void;
    reject: (reason?: any) => void;

    set disabled(value: boolean) {
        if (this.dialogRef.componentInstance) {
            this.dialogRef.componentInstance.disabled = value;
        }
    }

    constructor(
        private _router: Router,
        private _dialog: MatDialog,

        private _toastrSrv: ToastrService,
        private _steamSrv: SteamService,
    ) {
    }

    show(data: IDlgStoreAccessKeyData): Promise<any> {
        this.dialogRef = this._dialog.open(DlgStoreAccessKeyComponent, {
            backdropClass: 'mat-backdrop--long-scroll',
            panelClass: ['--ui'],
            data: {
                ...data,

                close: () => this.close(),
                transfer: (...args) => this.transfer(args[0])
            }
        });

        this._router.events
            .pipe(takeUntil(this.dialogRef.afterClosed()))
            .pipe(filter(e => e instanceof NavigationStart))
            .pipe(tap(() => this.close()))
            .subscribe();

        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    close() {
        this.dialogRef.close();
    }

    async transfer(count: any) {
        this.dialogRef.close();

        const toastTransferingRef = this._toastrSrv.show(ToastTransferingAccessKeyComponent, {
            timeout: 3000,
            data: {
                transfering: count
            }
        });

        try {
            await this._steamSrv.pushResources({ resourceType: PKG_ACCESS_KEY, amount: count });
        } catch (err) {
            console.error('inventory/base::dlgStorePixelSrv', err);
            this.reject(err);
            return;
        }

        toastTransferingRef.close();

        this._toastrSrv.show(ToastSuccessAccessKeyComponent, {
            data: {
                count,
                message: 'transfered to Steam'
            }
        });

        this.resolve({ type: TRANSFER_KEYS, payload: count });
    }
}
